// extracted by mini-css-extract-plugin
export default {"content":"TaxDocumentSummary_content__FQNAN"};